"use client";

import ManualVehicleSelection from "../CurrentVehicle/ManualVehicleSelection";

const ManualGroup = ({
  t,
  control,
  handleChange,
  hasEngineOpts,
  finalSelection,
  optionsList = {},
  fromMakeAndModel = false,
}) => {
  return (
    <>
      <ManualVehicleSelection
        name="make"
        control={control}
        options={optionsList.make}
        handleChange={handleChange}
        isDisable={!optionsList.make.length || fromMakeAndModel}
        label={t("current_vehicle.make.title")}
        placeholder={t("current_vehicle.make.placeholder")}
      />
      <ManualVehicleSelection
        name="model"
        control={control}
        options={optionsList.model}
        handleChange={handleChange}
        isDisable={!optionsList.model.length || fromMakeAndModel}
        label={t("current_vehicle.model.title")}
        placeholder={t("current_vehicle.model.placeholder")}
      />
      <ManualVehicleSelection
        name="year"
        control={control}
        options={optionsList.year}
        handleChange={handleChange}
        isDisable={!optionsList.year.length}
        label={t("current_vehicle.year.title")}
        placeholder={t("current_vehicle.year.placeholder")}
      />

      {hasEngineOpts && (
        <ManualVehicleSelection
          name="engine"
          control={control}
          handleChange={handleChange}
          options={optionsList.engine}
          isDisable={!optionsList.engine.length}
          label={t("current_vehicle.engine.title")}
          placeholder={t("current_vehicle.engine.placeholder")}
        />
      )}

      {optionsList.body?.length > 0 && (
        <>
          <ManualVehicleSelection
            name="body"
            control={control}
            options={optionsList.body}
            handleChange={handleChange}
            label={t("current_vehicle.body.title")}
            placeholder={t("current_vehicle.body.placeholder")}
          />

          {optionsList.kw_hp.length > 0 && (
            <ManualVehicleSelection
              name="kw_hp"
              control={control}
              options={optionsList.kw_hp}
              handleChange={finalSelection}
              label={t("current_vehicle.kw_hp.title")}
              placeholder={t("current_vehicle.kw_hp.placeholder")}
            />
          )}
        </>
      )}
    </>
  );
};

export default ManualGroup;
